
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research/category/[...slug]",
      function () {
        return require("private-next-pages/research/category/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research/category/[...slug]"])
      });
    }
  